<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> خودروهای اضافه شده </span>

    </div>

</div>

<main class="rtl px-2 py-3">

    <div [formGroup]="mdl_Search" class="row gx-3 gy-md-2 gy-3 p-2">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strEDate" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- جستجو -->
        
        <div class="col-12 col-md-1">

            <button class="w-100 btn btn-primary" (click)="search_NewCar()"> جستجو </button>

        </div>

        <!-- جدول اطلاعات -->

        <div class="border border-2 mt-3 p-2">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filterResult($event.target.value)">
    
            <div class="section border border-2 mt-2" style="height:calc(100vh - 185px);overflow: auto;">
    
                <table class="col-12 table table-hover table-striped rounded-3" id="Export_Excel">
    
                    <thead>
    
                        <tr class="">
    
                            <th class="text-center col-1"> # </th>
    
                            <th class="text-center"> تاریخ ثبت </th>
    
                            <th class="text-center"> کاربر ثبت کننده </th>
    
                            <th class="text-center"> خودرو </th>

                            <th class="text-center"> کد شناسایی </th>

                            <th class="text-center"> پایان اعتبار </th>
    
                        </tr>
    
                    </thead>
    
                    <tbody>
    
                        <tr (click)="openDetail(item.strUnitID)" class="col-12 text-center pointer" *ngFor="let item of lst_NewCar;let i = index">

                            <th> {{ i + 1 | faNum }} </th>

                            <td> {{ item.strDefinationDate | faNum }} </td>

                            <td> {{ item.strSystemUser_strFullName | faNum }} </td>

                            <td> {{ item.strFullName | faNum }} </td>

                            <td> {{ item.strUnitID | faNum }} </td>

                            <td> {{ item.strValidDate | faNum }} </td>
        
                        </tr>
    
                    </tbody>
    
                </table>
    
            </div>
    
        </div>

    </div>

</main>